import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { StatisticsData, StatisticsState } from "./types";

const initialState: Omit<StatisticsState, "statisticsForSelectedCountry"> & {
  data: StatisticsData[] | null;
} = {
  data: null,
  loading: false,
  error: null,
};

export const fetchStateStatisticsAsync = createAsyncThunk(
  "stateStatistics/fetchStateStatistics",
  async ({ stateId, year }: { stateId: string; year: string }) => {
    return await api.getStateStatistics(stateId, year);
  }
);

const stateStatisticsSlice = createSlice({
  name: "stateStatistics",
  initialState,
  reducers: {
    clearStateStatistics: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStateStatisticsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStateStatisticsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchStateStatisticsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch state statistics";
      });
  },
});

export const { clearStateStatistics } = stateStatisticsSlice.actions;
export default stateStatisticsSlice.reducer;
